import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

export interface SignupParams {
    email: string;
    landingPageConversion: boolean;
}

@Injectable({ providedIn: 'root' })
export class SignUpParamsResolver implements Resolve<SignupParams> {
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SignupParams> {
        const params = {
            email: route.queryParams.hasOwnProperty('email') ? route.queryParams.email : null,
            landingPageConversion: route.queryParams.hasOwnProperty('utm_source') && route.queryParams.utm_source === 'payhoa-lp',
        };

        return of(params);
    }
}
